export function arabicError(error: unknown): string {
  const code = typeof error === 'object' && error && 'code' in error ? String(error.code) : '';
  const messages: Record<string, string> = {
    'auth/invalid-credential': 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    'auth/user-disabled': 'هذا الحساب معطّل. تواصل مع المالك.',
    'auth/too-many-requests': 'محاولات كثيرة. انتظر قليلًا ثم حاول مجددًا.',
    'auth/network-request-failed': 'تعذر الاتصال بالشبكة. تحقق من اتصالك ثم أعد المحاولة.',
    'permission-denied': 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
    'unavailable': 'الخدمة غير متاحة الآن. تحقق من الاتصال ثم أعد المحاولة.',
    'app/timeout': 'استغرق الحفظ وقتًا أطول من المتوقع. تحقق من الشبكة ثم حاول مجددًا.',
    'request/already-decided': 'تم اتخاذ قرار على هذا الطلب مسبقًا.',
    'request/invalid-extension': 'بيانات طلب التمديد غير مكتملة.',
    'request/not-found': 'تعذر العثور على الطلب.',
    'functions/failed-precondition': 'المهمة مقفلة أو تغيّرت حالتها. حدّث الصفحة ثم حاول مجددًا.',
    'functions/not-found': 'تعذر العثور على المهمة.',
    'functions/permission-denied': 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  };
  return messages[code] ?? 'حدث خطأ غير متوقع. حاول مجددًا، وإن استمر الخطأ فتواصل مع الدعم.';
}
